import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import ProductDetail from "@/pages/ProductDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import SellerDashboard from "@/pages/SellerDashboard";
import AddProduct from "@/pages/AddProduct";
import SellerUpgrade from "@/pages/SellerUpgrade";
import SellerPaymentSuccess from "@/pages/SellerPaymentSuccess";
import SellerSales from "@/pages/SellerSales";
import SellerOrders from "@/pages/SellerOrders";
import Categories from "@/pages/Categories";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import Admin from "@/pages/Admin";

import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <div className="min-h-screen bg-[#050505] text-white grain">
            <Navbar />
            <main className="relative z-10">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/browse" element={<Browse />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
                <Route path="/orders/:id" element={<ProtectedRoute><OrderDetail /></ProtectedRoute>} />
                <Route path="/seller" element={<ProtectedRoute><SellerDashboard /></ProtectedRoute>} />
                <Route path="/seller/new" element={<ProtectedRoute><AddProduct /></ProtectedRoute>} />
                <Route path="/seller/sales" element={<ProtectedRoute><SellerSales /></ProtectedRoute>} />
                <Route path="/seller/orders" element={<ProtectedRoute><SellerOrders /></ProtectedRoute>} />
                <Route path="/seller/upgrade" element={<ProtectedRoute><SellerUpgrade /></ProtectedRoute>} />
                <Route path="/seller/payment-success" element={<ProtectedRoute><SellerPaymentSuccess /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
              </Routes>
            </main>
            <Footer />
            <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#121212", color: "#fff", border: "1px solid rgba(255,0,127,0.3)" } }} />
          </div>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
